const INITIAL_STATE = {
    esperandoSolicitacao: false,
    alerta: {},
  };


export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_VALIDAR_SIBE_INICIAR':
      return { ...state, esperandoSolicitacao: true};
    case 'REQUERIMENTO_VALIDAR_SIBE_RECEBIDO':
      return { ...state, esperandoSolicitacao: false };
    case 'REQUERIMENTO_INICIAR_CLOSE_MESSAGE':
      return { ...state, esperandoSolicitacao: false, alerta: {} };
    case 'REQUERIMENTO_VALIDAR_SIBE_ERROR':
      return { ...state, esperandoSolicitacao: false , alerta: { message: action.payload, severity: 'error' } };
    default:
      return state;
  }

}